var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropertyTypeBoolean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-43 -653)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 1,
    transform: "translate(43 653)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(49 662)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "HelveticaNeue-Medium,Helvetica Neue",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.168,
    y: 0
  }, "B")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyTypeBoolean);
export default __webpack_public_path__ + "static/media/propertyType-boolean.33ccaee4.svg";
export { ForwardRef as ReactComponent };